module.exports = __webpack_public_path__ + "img/pro_five_2.ebd7b77d.jpg";